var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-card-wrap"},[_c('div',{staticClass:"layout-width"},[_c('span',{staticClass:"zw"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"yw"},[_vm._v(_vm._s(_vm.subtitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }